import { render } from "./AdminHelpButton.vue?vue&type=template&id=0e0c975a&scoped=true"
import script from "./AdminHelpButton.vue?vue&type=script&lang=js"
export * from "./AdminHelpButton.vue?vue&type=script&lang=js"

import "./AdminHelpButton.vue?vue&type=style&index=0&id=0e0c975a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e0c975a"]])

export default __exports__